import { Document, Page, View } from '@react-pdf/renderer';

import {
  POAddressSection,
  PODetailInfoSection,
  POEventGroups,
  POFooter,
  POHeaderSection,
  POMetadataRow,
  PONotesSection,
  POPaymentAndSummary,
} from './PurchaseOrderPDF.components';
import { styles } from './PurchaseOrderPDF.css';
import { PurchaseOrderPDFProps } from './PurchaseOrderPDF.types';

export const PurchaseOrderPDF = (props: PurchaseOrderPDFProps) => {
  const {
    poStatus,
    isPaid,
    poDate,
    poNumber,
    externalPoNumber,
    vendorName,
    vendorAddress,
    vendorId,
    vendorContact,
    vendorPhone,
    vendorEmail,
    shipToName,
    shipToAddress,
    shipToPhone,
    buyerRep,
    buyerRepPhone,
    paymentMethod,
    paymentTerm,
    currency,
    eventGroups,
    payments,
    totalTickets,
    totalTicketCost,
    totalTaxes,
    totalExpenses,
    totalShipping,
    poTotal,
    totalPaid,
    balanceDue,
    purchaseOrderNotes,
    shipMethod,
    shipType,
    trackingNumber,
    estimatedArrival,
    shippingNotes,
  } = props;

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        {/* Header: Logo placeholder + "Purchase Order" title + status */}
        <POHeaderSection poStatus={poStatus} isPaid={isPaid} />

        {/* Purple divider */}
        <View style={styles.divider} />

        {/* Metadata row: Date, P.O No., External PO# */}
        <POMetadataRow
          poDate={poDate}
          poNumber={poNumber}
          externalPoNumber={externalPoNumber}
        />

        {/* Vendor / Ship To addresses */}
        <POAddressSection
          vendorName={vendorName}
          vendorAddress={vendorAddress}
          shipToName={shipToName}
          shipToAddress={shipToAddress}
          shipToPhone={shipToPhone}
        />

        {/* Detail info: Vendor ID, Contact, Buyer's Rep, Payment Method */}
        <PODetailInfoSection
          vendorId={vendorId}
          vendorContact={vendorContact}
          vendorPhone={vendorPhone}
          vendorEmail={vendorEmail}
          buyerRep={buyerRep}
          buyerRepPhone={buyerRepPhone}
          paymentMethod={paymentMethod}
          paymentTerm={paymentTerm}
        />

        {/* Event groups with ticket tables */}
        <POEventGroups eventGroups={eventGroups} currency={currency} />

        {/* Payment Information + Summary + Notes + Shipping */}
        <POPaymentAndSummary
          payments={payments}
          totalTickets={totalTickets}
          totalTicketCost={totalTicketCost}
          totalTaxes={totalTaxes}
          totalExpenses={totalExpenses}
          totalShipping={totalShipping}
          poTotal={poTotal}
          totalPaid={totalPaid}
          balanceDue={balanceDue}
          currency={currency}
        />

        {/* Purchase Order Notes */}
        <PONotesSection
          purchaseOrderNotes={purchaseOrderNotes}
          shipMethod={shipMethod}
          shipType={shipType}
          trackingNumber={trackingNumber}
          estimatedArrival={estimatedArrival}
          shippingNotes={shippingNotes}
        />

        {/* Footer */}
        <POFooter />
      </Page>
    </Document>
  );
};
